import type { DocCollection } from '@blocksuite/store';
import { useDocCollectionPage } from '@pique/core/hooks/use-block-suite-workspace-page';
import { useAtomValue } from 'jotai';
import { type ReactNode, Suspense } from 'react';

import { useBlockSuitePagePreview } from './use-block-suite-page-preview';

interface PagePreviewProps {
  docCollection: DocCollection;
  pageId: string;
  emptyFallback?: ReactNode;
}

const PagePreviewInner = ({
  docCollection: workspace,
  pageId,
  emptyFallback,
}: PagePreviewProps) => {
  const page = useDocCollectionPage(workspace, pageId);
  const previewAtom = useBlockSuitePagePreview(page);
  const preview = useAtomValue(previewAtom);
  const res = preview ? preview : null;
  return res || emptyFallback;
};

export const PagePreview = (props: PagePreviewProps) => {
  return (
    <Suspense>
      <PagePreviewInner {...props} />
    </Suspense>
  );
};
